<template>
  <div id="app">
    <keep-alive>
	    <router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  }
};
</script>

<style>
@import url('./assets/css/common.css');
</style>



// WEBPACK FOOTER //
// src/App.vue